require('es6-promise').polyfill()
import axios from 'axios'
import { forEachPolyfill, includesPolyfill } from './helpers'

forEachPolyfill()
includesPolyfill()

const displayMatches = (matches, query) => {
	const container = document.querySelector('.search-results')
	container.style.display = 'block'
	let items = []
	matches.forEach(match => {
		const { title, img, url, type, author } = match
		const item = `
			<a href="${url}" class="search-results__item">     
				${img ? '<img src=' + img + '>' : ''}
				<div>
					<p>${title}</p>
					<p>${type} ${type === 'Blog' ? '• ' + author : ''}</p>
				</div>
			</a>`
		items.push(item)
	})
	container.innerHTML = items.join('')
	if (query.length && items.length === 0) {
		container.innerHTML = `<p class="search-results__item">Geen resultaten voor "${query}" ...</p>`
	}
}

const findMatches = (query, results) => {

	console.log(results);

	const matches = results
		.filter(result => {
			const { title } = result
			return title.toLowerCase().includes(query.toLowerCase())
		})
	displayMatches(matches, query)
}

export default function (el) {
	const input = document.querySelector(el)
	if (!input) return
	const container = document.querySelector('.search-results')
	let results = null
	axios.get(`/wp-json/rest/data`)
		.then((res) => {
			results = res.data
		})
		.catch((err) => console.log(err))

	input.addEventListener('keyup', () => {
		const query = input.value
		if (query.length > 2) {
			findMatches(query, results)
		} else {
			container.style.display = 'none'
		}
	})
}
